import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]

import type { IconFonts } from "@/types";

interface Props {
    label?: string;
    type?: "outlined" | "raised" | "tertiary" | "tertiary__active";
    iconFont?: IconFonts;
    trailingIcon?: string;
    leadingIcon?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MdcButton',
  props: {
    label: {},
    type: {},
    iconFont: { default: "ms" },
    trailingIcon: {},
    leadingIcon: {}
  },
  setup(__props: any) {

const props = __props;

function fontAwesomeIconClass(icon: string): string {
    return props.iconFont + " " + icon;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["mdc-button", {
            'mdc-button--outlined': props.type === 'outlined',
            'mdc-button--raised': props.type === 'raised',
            'mdc-button--tertiary active': props.type === 'tertiary__active',
            'mdc-button--tertiary': props.type === 'tertiary',
            'mdc-button--icon-leading': props.leadingIcon,
            'mdc-button--icon-trailing': props.trailingIcon,
        }])
  }, [
    (props.leadingIcon && props.iconFont === 'ms')
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: "mdc-button__icon material-symbols-outlined",
          "aria-hidden": "true",
          textContent: _toDisplayString(props.leadingIcon)
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (props.leadingIcon && props.iconFont !== 'ms')
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass(["mdc-button__icon", fontAwesomeIconClass(props.leadingIcon)]),
          "aria-hidden": "true"
        }, null, 2))
      : _createCommentVNode("", true),
    (props.label)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "mdc-button__label",
          textContent: _toDisplayString(props.label)
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (props.trailingIcon && props.iconFont === 'ms')
      ? (_openBlock(), _createElementBlock("i", {
          key: 3,
          class: "mdc-button__icon material-symbols-outlined",
          "aria-hidden": "true",
          textContent: _toDisplayString(props.trailingIcon)
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (props.trailingIcon && props.iconFont !== 'ms')
      ? (_openBlock(), _createElementBlock("i", {
          key: 4,
          class: _normalizeClass(["mdc-button__icon", fontAwesomeIconClass(props.trailingIcon)]),
          "aria-hidden": "true"
        }, null, 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})